<script lang="ts">
import { defineComponent, provide, ref } from 'vue'
import { generateRoomsStore, roomsStoreKey } from './libs/roomsStore'
import { modalsKey } from './injectionKeys'
import { allowPolling, pollingAllowed } from './libs/polling'
import { generateCurrentUserStore, currentUserStoreKey } from './libs/currentUserStore'
import { generateFollowersStore, followsStoreKey } from './libs/followsStore'
import { generateRoomStore, roomStoreKey } from './libs/roomStore'
import { generateNotificationStore, notificationStoreKey } from './libs/notificationStore'
import Notificator from './components/Notificator.vue'
export default defineComponent({
  components: { Notificator },
  setup () {
    const modals = ref<symbol[]>([])
    provide(modalsKey, modals)
    const roomsStore = generateRoomsStore()
    provide(roomsStoreKey, roomsStore)
    const currentUserStore = generateCurrentUserStore()
    provide(currentUserStoreKey, currentUserStore)
    const followsStore = generateFollowersStore()
    provide(followsStoreKey, followsStore)
    const roomStore = generateRoomStore()
    provide(roomStoreKey, roomStore)
    const notificationStore = generateNotificationStore()
    provide(notificationStoreKey, notificationStore)
    return {
      modals,
      allowPolling,
      pollingAllowed
    }
  }
})
</script>

<template>
  <router-view />
  <transition name="v">
    <div v-if="modals.length" class="ModalBg"></div>
  </transition>
  <Notificator />
  <div v-show="!pollingAllowed" class="Sleep" @click="allowPolling">
    <span class="material-symbols-rounded">bedtime</span>
  </div>
</template>

<style lang="scss">
:root {
  --bg-color: #EEEAE5;
  --tx-color: #5C5550;
  --tx-color-light: #8F877C;
  --border-color: #cecac4;
  --orange: #F70;
  --green: #791;
  --red: #C00;
  --radius: 10px;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  max-width: 100%;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-track {
  background: var(--bg-color);
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 5px;
}
html {
  background: #FFFCF5;
}
body {
  min-width: 320px;
  min-height: 100vh;
  font-family: 'M PLUS Rounded 1c';
  font-size: 14px;
  color: var(--tx-color);
  line-height: 1.5;
}
* {
  user-select: none;
}
li {
  list-style: none;
}
a {
  color: var(--orange);
  font-weight: bold;
}
h1 {
}
h2 {
  padding-bottom: 4px;
  margin-bottom: 10px;
  font-size: 15px;
  border-bottom: 1px dashed var(--border-color);
  &:not(:first-child) {
    margin-top: 25px;
  }
  i {
    color: var(--tx-color-light);
    vertical-align: text-bottom;
  }
}
h3 {
  padding-bottom: 3px;
  margin-bottom: 10px;
  font-size: 14px;
  &:not(:first-child) {
    margin-top: 20px;
  }
  i {
    color: var(--tx-color-light);
    vertical-align: text-bottom;
  }
}
hr {
  margin: 15px 0;
  border-top: 1px dashed var(--border-color);
  border-bottom: 0;
}
input[type="text"],
input[type="password"],
textarea,
.button,
button {
  font-family: 'M PLUS Rounded 1c';
  display: block;
  padding: 8px 12px;
  width: 100%;
  border: none;
  outline: none;
  line-height: 1.5;
}
input[type="text"],
input[type="password"],
textarea {
  box-shadow: inset 0 0 7px rgba(0, 0, 0, 0.15);
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  user-select: auto;
}
select {
  padding: 8px 10px;
  background-color: white;
  border: 1px solid var(--border-color);
  box-shadow: inset 0 0 7px rgb(0 0 0 / 20%);
  border-radius: var(--radius);
  outline: none;
}
.button,
button {
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--orange);
  border-radius: 50px;
  font-size: 13px;
  font-weight: bold;
  text-decoration: none;
  color: #FFF;
  cursor: pointer;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2), inset 0 -1px 0 rgba(0, 0, 0, 0.07), inset 0 1px 0 rgba(255, 255, 255, 0.2);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
  user-select: none;
  &.red {
    background: var(--red);
  }
  &.cancel {
    background: var(--tx-color-light);
  }
  &.disabled {
    background: #CCC;
    cursor: default;
  }
  .material-symbols-rounded {
    font-size: 18px;
    margin-right: 3px;
  }
}
.CommonList {
  padding-left: 1.5em;
  & > li {
    list-style: disc;
    &:not(:first-child) {
      margin-top: 3px;
    }
  }  
}
</style>

<style lang="scss" scoped>
.ModalBg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.7);
  transition: 0.2s;
  backdrop-filter: blur(6px);
  &.v-enter-from,
  &.v-leave-to {
    background: rgba(0, 0, 0, 0);
    backdrop-filter: blur(0);
  }
  &.v-enter-to,
  &.v-leave-from {
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(6px);
  }
}
.Sleep {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  .material-symbols-rounded {
    font-variation-settings: 'FILL' 1;
  }
  span {
    font-size: 70px;
    color: rgba(255, 255, 255, 0.4);
  }
}
</style>
